module.exports = __webpack_public_path__ + "static/media/siva.b2a90674.jpg";